import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Coeur = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 82.2 73.93">
  <G fill={color}>
    <Path d="M60.26,0c-9.08,0-15.8,6.32-19.16,10.33C37.75,6.32,31.02,0,21.95,0,8.2,0,0,9.01,0,24.11c0,19.73,37.83,48.07,39.44,49.27.49.37,1.08.55,1.66.55s1.17-.18,1.67-.55c1.61-1.2,39.44-29.54,39.44-49.27,0-15.1-8.2-24.11-21.95-24.11Z"/>
  </G>
</Svg>
);
};

export default Coeur;
